import React from 'react';
import { Link } from 'react-router';
import {
	Dropdown,
	Menu
} from 'semantic-ui-react';
import { observer } from 'mobx-react';
import userStore from '../stores/UserStore';

const TopMenu = observer(() => {
	if (userStore.user.user_id !== 0) {
		return (
			<Menu inverted fixed="top">
				<Menu.Item as={Link} to="/" header>Scheduler</Menu.Item>
				<Menu.Item as={Link} to="/">
					Request Appointment
				</Menu.Item>
				{userStore.user.role === 'Admin' && <Dropdown className='link item' text='Admin'>
					<Dropdown.Menu>
						<Dropdown.Item as={Link} to="/admin/requests">Requests</Dropdown.Item>
						<Dropdown.Item as={Link} to="/admin/regions">Regions/Employees</Dropdown.Item>
						<Dropdown.Item as={Link} to="/admin/accounts">Accounts/Users</Dropdown.Item>
						<Dropdown.Item as={Link} to="/admin/blocked-days">Blocked Days</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>}
				<Dropdown icon='settings' className='link item right'>
					<Dropdown.Menu>
						<Dropdown.Item as={Link} to="/profile">Account</Dropdown.Item>
						<Dropdown.Item as={Link} to="/logout">Logout</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>
			</Menu>
		)
	}
	return ( <div></div> )
});

export default TopMenu;



/** WEBPACK FOOTER **
 ** ./src/components/TopMenu.jsx
 **/